// extracted by mini-css-extract-plugin
export var subtitle = "_d7-2";
export var title = "_d7-0";
export var titleNoWrap = "_d7-1";